import React from "react";
import { View, StyleSheet } from "react-native";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionDescription from "../general/NtSectionDescription";
import NtMaterialIcon from "../../../components/NtMaterialIcon";
import NtText from "../../../components/NtText";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import { useMobile } from "../../../hooks/useMobile";

function NtTelehealthContactTracingSection({}) {
  const isMobile = useMobile();

  const features = [
    {
      id: 1,
      text: "Tracing is based on controlled public spaces",
    },
    {
      id: 2,
      text: "Anonymized Public ID is tracked via the app, a wearable, and/or video surveillance",
    },
    {
      id: 3,
      text: "Algorithms will track and instruct the contacts of infected guests to engage in safety protocols",
    },
    {
      id: 4,
      text: "Guests can be notified by the messaging system and/or voice calls by ship staff",
    },
  ];
  const benefits = [
    {
      id: 1,
      text: "Minimize Spread of Disease",
    },
    {
      id: 2,
      text: "Maintain Anonymity whenever possible",
    },
    {
      id: 3,
      text: "Once a sick person is identified, contact tracing can be enabled to locate, test, and potentially quarantine people at risk.",
    },
    {
      id: 4,
      text: "Identifies locations where an infected person spent time so those areas can receive extra sanitization.",
    },
  ];

  const renderBox = (title, list, containerStyle) => {
    return (
      <View
        style={[
          {
            borderWidth: 1,
            borderColor: "#2c4d7a",
            backgroundColor: "#050f1d",
            borderRadius: 15,
            padding: 30,
          },
          containerStyle,
        ]}
      >
        <NtSectionTitle style={{ textAlign: "left" }}>{title}</NtSectionTitle>

        <View style={{ marginTop: 15 }}>
          {list?.map((each, index) =>
            renderRow(each, index != list?.length - 1)
          )}
        </View>
      </View>
    );
  };

  const renderRow = (item, showDevider = true) => {
    return (
      <View key={item.id}>
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            paddingTop: 15,
            paddingBottom: 15,
          }}
        >
          <NtMaterialIcon name="asterisk" size={26} color={"#006aff"} />
          <NtText
            style={{
              marginLeft: 10,
              color: "white",
              fontSize: 13,
              fontWeight: "500",
            }}
          >
            {item.text}
          </NtText>
        </View>
        {showDevider && (
          <View style={{ backgroundColor: "#2c4d7a", height: 1 }} />
        )}
      </View>
    );
  };

  return (
    <NtMarketingSectionContainer style={styles.container}>
      <View style={{ width: "100%" }}>
        <NtSectionTitle>PRIVATE & ANONYMIZED CONTACT TRACING</NtSectionTitle>
        <NtSectionDescription style={{ marginTop: 15 }}>
          When a contagious guest or crew member has been identified, contact
          tracing helps identify other passengers who may have had significant
          contact with that person so they can also be tested and quarantined,
          if necessary.
        </NtSectionDescription>

        <View
          style={{ marginTop: 25, flexDirection: isMobile ? "column" : "row" }}
        >
          {renderBox("Features and Functionalities", features, {
            marginRight: isMobile ? 0 : 10,
            flex: 1,
          })}
          {renderBox("Benefits", benefits, {
            flex: 1,
            marginTop: isMobile ? 10 : 0,
          })}
        </View>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: {
    paddingTop: 60,
    paddingBottom: 60,
    alignItems: "center",
  },
});

export default NtTelehealthContactTracingSection;
